import { render, staticRenderFns } from "./ReadingTime.vue?vue&type=template&id=bbaeb02a"
import script from "./ReadingTime.vue?vue&type=script&lang=js"
export * from "./ReadingTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports